import { PaginationInterface } from './types';

export const TOKEN_KEY: string = 'TENDER_TOKEN';

export const BASE_NAME: string = '/tender';

export const BASE_MOBILE_NAME: string = '/tender-mobile';

export const TENDER_REDIRECT: string = 'TENDER_REDIRECT';

export const IS_DEV: boolean = process.env.NODE_ENV === 'development';

export const IS_DEV_CONFIG: boolean =
  process.env.REACT_APP_ENV === 'development';

export const IS_PROD: boolean = process.env.REACT_APP_ENV === 'production';

export const BASE_ROUTER_URL: string = BASE_NAME;

export const DEFAULT_DATETIME_FORMAT: string = 'YYYY-MM-DD HH:mm:ss';

export const DEFAULT_MINUTES_FORMAT: string = 'YYYY-MM-DD HH:mm';

export const DEFAULT_DATE_FORMAT: string = 'YYYY-MM-DD';

export const BASE_URL: string = process.env.REACT_APP_BASE_URL ?? '';

export const SOCKET_URL: string = process.env.REACT_APP_SOCKET_URL ?? '';

export const DEFAULT_ROUTER: string = '/pendingApproval';
export const FONT = '14px PingFang SC, -apple-system, Helvetica, sans-serif';

export const CURRENT = 1;
export const PAGESIZE = 20;
export const EMAIL_REGEX =
  /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,9}$/;
export const PHONE_REGEX =
  /^((\d{3,4}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/;

export const DEFAULT_PAGINATION: PaginationInterface = {
  pageNumber: CURRENT,
  pageSize: PAGESIZE,
  total: 0
};

export const DIC_FIELD_NAMES = { label: 'dictValue', value: 'dictKey' };

export enum ROLE_KEYS_MAP {
  admin = 'admin',
  sales = 'sales',
  sector = 'sector',
  dealer = 'dealer'
}

export const COMMON_PLACEHOLDER = '$$';

export const POWER_BI_URL =
  'https://onedata.zeiss.com.cn/home/index.html#/reportCenter/PBIViews?reportID=676311612493907&page=ReportSection';

export const POWER_BI_URL_2 =
  'https://onedata.zeiss.com.cn/home/index.html#/reportCenter/PBIViews?reportID=676311612493909&page=ReportSection';

export const LOGIN_ORIGIN = 'LOGIN_ORIGIN';

export const LOGIN_ORIGIN_KEY = 'Dealer';
